import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store, history, persistor } from "../redux/store";
import { PersistGate } from "redux-persist/integration/react";
import Register from "../components/Register/Register";
import PaymentSetup from "../components/PaymentSetup/PaymentSetup";
import RegistrationInsuranceVerification from "../components/RegistrationSetup/Insurance/RegistrationInsuranceVerification/RegistrationInsuranceVerification";
import RegistrationInsuranceInformation from "../components/RegistrationSetup/Insurance/RegistrationInsuranceInformation/RegistrationInsuranceInformation";
import RegistrationInsuranceChecking from "../components/RegistrationSetup/Insurance/RegistrationInsuranceChecking/RegistrationInsuranceChecking";
import RegistrationInsuranceCoverageFound from "../components/RegistrationSetup/Insurance/RegistrationInsuranceCoverageFound/RegistrationInsuranceCoverageFound";
import RegistrationCardOnFile from "../components/RegistrationSetup/CardOnFile/RegistrationCardOnFile/RegistrationCardOnFile";
import RegistrationDietitianSelection from "../components/RegistrationSetup/Dietitian/RegistrationDietitianSelection/RegistrationDietitianSelection";
import RegistrationDietitianProfile from "../components/RegistrationSetup/Dietitian/RegistrationDietitianProfile/RegistrationDietitianProfile";
import RegistrationAppointmentTime from "../components/RegistrationSetup/Appointment/RegistrationAppointmentTime/RegistrationAppointmentTime";
import RegistrationCalendlyBooking from "../components/RegistrationSetup/Appointment/RegistrationCalendlyBooking/RegistrationCalendlyBooking";
import RegistrationBookingConfirmation from "../components/RegistrationSetup/Appointment/RegistrationBookingConfirmation/RegistrationBookingConfirmation";
import RegistrationAppointmentConfirmed from "../components/RegistrationSetup/Appointment/RegistrationAppointmentConfirmed/RegistrationAppointmentConfirmed";
import RegistrationAppDownload from "../components/RegistrationSetup/AppDownload/RegistrationAppDownload/RegistrationAppDownload";
import RegistrationAllSet from "../components/RegistrationSetup/AppDownload/RegistrationAllSet/RegistrationAllSet";
import RegistrationNoRdAvailable from "../components/RegistrationSetup/NoRdAvailable/RegistrationNoRdAvailable";
import RegistrationNoPreferenceAppointmentTime from "../components/RegistrationSetup/Appointment/RegistrationNoPreferenceAppointmentTime/RegistrationNoPreferenceAppointmentTime";
import RegistrationNoPreferenceDietitianProfile from "../components/RegistrationSetup/Dietitian/RegistrationNoPreferenceDietitianProfile/RegistrationNoPreferenceDietitianProfile";
import RegistrationNoPreferenceCalendlyBooking from "../components/RegistrationSetup/Appointment/RegistrationNoPreferenceCalendlyBooking/RegistrationNoPreferenceCalendlyBooking";
import Welcome from "../components/Welcome/Welcome";
import Insurence from "../components/Insurence/Insurence";
import Schedule from "../components/Schedule/Schedule";
import StaticPage from "../components/StaticPage/StaticPage";
import Calendly from "../components/Calendly/Calendly";
import Slots from "../components/Slots/Slots";
import RDList from "../components/RDList/RDList";
import ScheduleAppointment from "../components/ScheduleAppointment/ScheduleAppointment";
import AppointmentConfirmation from "../components/AppointmentConfirmation/AppointmentConfirmation";
import BookMobileAppointment from "../components/BookMobileAppointment/BookMobileAppointment";
import Preference from "../components/Preference/Preference";
import DiscoveryQueue from "../components/DiscoveryQueue/DiscoveryQueue";
import AddCard from "../components/AddCard/AddCard";
import { useEffect } from "react";
import InitializeLogRocket from "../components/InitializeLogRocket";
import AnalyticsRouteTracker from "../components/AnalyticsRouteTracker/AnalyticsRouteTracker";

const ScrollToTop = () => {
  const location = useLocation(); // Ensure this is inside Router

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

const Routes = (props) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router history={history}>
          <ScrollToTop />
          <AnalyticsRouteTracker />
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/register" />} />
            <Route exact path="/register" component={Welcome} />
            <Route
              exact
              path="/register/account/payment"
              component={PaymentSetup}
            />
            <Route
              exact
              path="/register/account/no-rd-available"
              component={RegistrationNoRdAvailable}
            />
            <Route
              exact
              path="/register/account/insurance/checking"
              component={RegistrationInsuranceChecking}
            />
            <Route
              exact
              path="/register/account/insurance/coverage"
              component={RegistrationInsuranceCoverageFound}
            />
            <Route
              exact
              path="/register/account/insurance/details"
              component={RegistrationInsuranceInformation}
            />
            <Route
              exact
              path="/register/account/insurance"
              component={RegistrationInsuranceVerification}
            />
            <Route
              exact
              path="/register/account/card"
              component={RegistrationCardOnFile}
            />
            <Route
              exact
              path="/register/account/dietitians"
              component={RegistrationDietitianSelection}
            />
            <Route
              exact
              path="/register/account/no-preference/appointments"
              component={RegistrationNoPreferenceAppointmentTime}
            />
            <Route
              exact
              path="/register/account/no-preference/dietitians/:rdId"
              component={RegistrationNoPreferenceDietitianProfile}
            />
            <Route
              exact
              path="/register/account/no-preference/calendly-booking"
              component={RegistrationNoPreferenceCalendlyBooking}
            />
            <Route
              exact
              path="/register/account/dietitians/:rdId"
              component={RegistrationDietitianProfile}
            />
            <Route
              exact
              path="/register/account/appointments"
              component={RegistrationAppointmentTime}
            />
            <Route
              exact
              path="/calendly-booking"
              component={RegistrationCalendlyBooking}
            />
            <Route
              exact
              path="/booking-confirmation"
              component={RegistrationBookingConfirmation}
            />
            <Route
              exact
              path="/register/account/confirmation"
              component={RegistrationAppointmentConfirmed}
            />
            <Route
              exact
              path="/register/account/download-app"
              component={RegistrationAppDownload}
            />
            <Route
              exact
              path="/register/account/all-set"
              component={RegistrationAllSet}
            />
            <Route path="/register/account" component={Register} />
            <Route path="/insurance" component={Insurence} />
            <InitializeLogRocket>
              <Route path="/add-card" component={AddCard} />
              <Route path="/static-page" component={StaticPage} />
              <Route
                exact
                path="/terms"
                render={() => <Redirect to="/static-page?type=terms" />}
              />
              <Route
                exact
                path="/privacy"
                render={() => <Redirect to="/static-page?type=privacy" />}
              />
              <Route
                exact
                path="/hipaa-consent"
                render={() => <Redirect to="/static-page?type=hippa" />}
              />
              <Route
                exact
                path="/hippa-consent"
                render={() => <Redirect to="/static-page?type=hippa" />}
              />
              <Route
                exact
                path="/payment"
                render={() => <Redirect to="/static-page?type=payment" />}
              />
              <Route
                path="/book-mobile-appointment"
                component={BookMobileAppointment}
              />
              <Route path="/schedule" component={Schedule} />
              <Route path="/calendly" component={Calendly} />
              <Route path="/rd-slots" component={Slots} />
              <Route path="/rd-list" component={RDList} />
              <Route
                path="/schedule-appointment"
                component={ScheduleAppointment}
              />
              <Route
                path="/appointment-confirmation"
                component={AppointmentConfirmation}
              />
              <Route path="/preference" component={Preference} />
              <Route path="/discovery-queue" component={DiscoveryQueue} />
            </InitializeLogRocket>
          </Switch>
        </Router>
      </PersistGate>
    </Provider>
  );
};
export default Routes;
